<template>
  <!--  <v-dialog :persistent="true" max-width="unset" v-model="inDialog"-->
  <!--            @keydown.esc="onCancel"-->
  <!--             hide-overlay-->
  <!--  >-->
  <div style="margin: 10px; ">
    <v-card style="alignment: center">
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
              $t(formName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs4>
              <v-text-field
                  :data-vv-as="$t('Mã quy trình')"
                  :error-messages="errors.first('code')"
                  :label="$t('Mã quy trình')"
                  disabled
                  maxLength="250"
                  name="code"
                  type="text"
                  v-model.trim="item.code"
                  v-validate="'required'"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-select
                  :data-vv-as="$t('lang.procedureWh.numberG')"
                  :error-messages="errors.first('numberG')"
                  :items="numberGList"
                  :label="$t('lang.procedureWh.numberG')"
                  item-text="text"
                  item-value="value"
                  name="numberG"
                  ref="numberG"
                  v-model="item.numberG"
                  v-on:change="onViewProcedure"
              />
            </v-flex>
            <v-flex xs4>
              <v-select
                  :data-vv-as="$t('lang.material.materialType')"
                  :error-messages="errors.first('typeId')"
                  :items="materialTypes"
                  :label="$t('lang.material.materialType')"
                  item-text="name"
                  item-value="id"
                  name="typeId"
                  ref="typeId"
                  v-model="item.typeId"
                  v-on:change="onViewProcedure"
                  v-validate="'required'"
              />
            </v-flex>
            <!--            <v-flex xs4>-->
            <!--              <v-btn @click="onEdit" color="primary" v-if="isView=='1' &&isAllowEdit=='1'">-->
            <!--                <v-icon dark left>edit</v-icon>-->
            <!--                {{ $t("lang.common.edit") }}-->
            <!--              </v-btn>-->
            <!--              <v-btn @click="onSave" color="primary" v-if="isView=='0'">-->
            <!--                <v-icon dark left>save</v-icon>-->
            <!--                {{ $t("lang.common.save") }}-->
            <!--              </v-btn>-->
            <!--              <v-btn @click="onCancel" color="error">-->
            <!--                <v-icon dark left>cancel</v-icon>-->
            <!--                {{ $t("lang.common.cancel") }}-->
            <!--              </v-btn>-->
            <!--            </v-flex>-->
          </v-layout>
          <div style="text-align: right">

          </div>
        </v-card-text>
        <!--        <div v-if="lstMaterial.length > 0" style="height: 50px; font-weight: bold; font-size: 15px">Danh sách vật tư ao Mẹ</div>-->
        <table v-if="lstMaterial.length > 0">
          <tr>
            <td style="height: 50px">
              <label style="font-weight: bold ; color: black;">
                Danh sách vật tư ao Mẹ
              </label>
            </td>
          </tr>
        </table>
        <v-data-table
            :headers="lstMaterial"
            :items="lstMotherDay"
            class="procedure_index_tb"
            hide-actions
            id="parentDay"
            v-if="lstMaterial.length > 0"
        >
          <template slot="headers">

            <tr>
              <th class="fixed" colspan="2" style="text-align:center; background: powderblue; border : 1px solid grey">
                <label style="font-weight: bold; color: black;">
                  Ao mẹ
                </label>

              </th>
              <th :colspan="lstMaterial.length"
                  style="text-align:center; background: powderblue; border : 1px solid grey">
                <label style="font-weight: bold; color: black;">
                  <select-box-view
                      :keyValue="item.typeId"
                      :listObject="listMaterialType"
                  />
                </label>

              </th>
            </tr>
            <tr>
              <th class="fixed" style=" border : 1px solid grey; color: black; background: lightgrey"
                  v-if="lstMaterial.length > 0">
                Ngày
              </th>
              <th class="fixed2" style=" border : 1px solid grey; color: black; background: lightgrey"
                  v-if="lstMaterial.length > 0">
                Tuổi tôm
              </th>
              <th style=" border : 1px solid grey; color: black; background: white" v-for="header in lstMaterial">
                <select-box-view class="labelText"
                    :keyValue="header.materialId"
                    :listObject="listObject"
                />
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <procedure-wh-day-list-item
                :ref="'dayItem' + props.index"
                :row="props"
                @keyProcess="keyProcess"
                group="t1"
            />
          </template>
        </v-data-table>
        <table v-if="lstMaterial.length > 0">
          <tr>
            <td style="height: 50px">
              <label style="font-weight: bold ; color: black;">
                Danh sách vật tư ao con
              </label>
            </td>
          </tr>
        </table>
        <v-data-table
            :headers="lstMaterial"
            :items="lstChildrenDay"
            class="procedure_index_tb"
            hide-actions
            id="childrenDay"
            v-if="lstMaterial.length > 0"
        >
          <template slot="headers">
            <tr>
              <th class="fixed" colspan="2" style="text-align:center; background: powderblue; border : 1px solid grey">
                <label style="font-weight: bold; color: black;">
                  Ao con
                </label>

              </th>
              <th :colspan="lstMaterial.length"
                  style="text-align:center; background: powderblue; border : 1px solid grey">
                <label style="font-weight: bold; color: black;">
                  <select-box-view
                      :keyValue="item.typeId"
                      :listObject="listMaterialType"
                  />
                </label>

              </th>
            </tr>
            <tr>
              <th class="fixed" style=" border : 1px solid grey; color: black; background: lightgrey"
                  v-if="lstMaterial.length > 0">
                Ngày
              </th>
              <th class="fixed2" style=" border : 1px solid grey; color: black; background: lightgrey"
                  v-if="lstMaterial.length > 0">
                Tuổi tôm
              </th>
              <th style=" border : 1px solid grey; color: black; background: white" v-for="header in lstMaterial">
                <select-box-view class="labelText"
                    :keyValue="header.materialId"
                    :listObject="listObject"
                />
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <procedure-wh-day-list-item
                :ref="'dayItem' + props.index"
                :row="props"
                @keyProcess="keyProcess"
                group="t2"
            />
          </template>
        </v-data-table>

        <div style="text-align: right">

          <v-btn @click="onSave" color="primary">
            <v-icon dark left>save</v-icon>
            {{ $t("lang.common.save") }}
          </v-btn>
<!--          <v-btn @click="onMigrate" color="primary">-->
<!--            <v-icon dark left>save</v-icon>-->
<!--            {{ $t("Migrate") }}-->
<!--          </v-btn>-->
          <v-btn @click="onCancel" color="error">
            <v-icon dark left>keyboard_backspace</v-icon>
            {{ $t("lang.common.back") }}
          </v-btn>
        </div>

        <!-- </v-container> -->
      </v-form>

    </v-card>
    <go-top></go-top>
  </div>
  <!--  </v-dialog>-->
</template>

<script>
  import {message} from "../../../services";
  import axios from "axios";
  import {areaContants} from "@/constants";
  import {mapGetters} from "vuex";
  import ProcedureWhDayListItem from "./component/ProcedureWhDayListItem";
  import SelectBoxView from "../../../components/form/SelectBoxView";
  import {router} from "../../../router";
  import GoTop from '@inotom/vue-go-top';

  export default {
    name: "procedure-wh-day-list",
    components: {SelectBoxView, ProcedureWhDayListItem, message, axios, GoTop},
    props: {
      propsItem: {
        type: Object,
        default: () => {
                    return {}
                }
      },
      cDialog: {
        type: Boolean,
        default: false,
      },
      areas: {
        type: Array,
        default: () => [],
      },
      rowsPerPageItems: {
        type: [Array, Number],
        default: () => [10, 20, 30, 40, 50]
      },
      timeReload: {
        type: [Number],
        default: 0
      }
    },
    data: () => {
      return {
        formName: "Nhập số liệu",
        areaStatus: areaContants.areaStatus,
        numberGList: areaContants.numberGList,
        item: {
          status: 1,
        },
        inDialog: false,
        searchItems: [],
        createItems: [],
        listObject: [],
        listMaterialType: [],
        searchUrl: "",
        materialTypes: [],
        isAllowEdit: 1,
        numberColumnSpanAll: 3,
        fields: [
          {
            value: "index",
            text: "lang.common.index",
            width: "5%",
            sortable: false,
          },

          {
            type: "select",
            items: [],
            itemText: "name",
            itemValue: "id",
            name: 'typeId',
            value: 'typeId',
            text: 'lang.request.typeId',
            width: "10%",
            sortable: false,
            search: true,
          },

          {
            type: "select",
            items: [],
            itemText: "name",
            itemValue: "id",
            name: 'materialId',
            value: 'materialId',
            text: 'lang.request.materialId',
            width: "10%",
            sortable: false,
            search: true,
          },
          {
            value: 'custom_action',
            text: "lang.request.delete",
            icon: "delete",
            event: "onDeleteFromProcedure",
            width: "10%",
            color: "primary"
          }
        ],
      };
    },
    computed: {
      ...mapGetters({
        lstMotherDay: 'procedureWh/lstMotherDay',
      }),
      ...mapGetters({
        lstChildrenDay: 'procedureWh/lstChildrenDay',
      }),
      ...mapGetters({
        lstMaterial: 'procedureWh/lstMaterial',
      }),
      ...mapGetters({
        isView: 'procedureWh/isView',
      }),


    },
    // watch: {
    //   propsItem: {
    //     handler(value) {
    //       //console.log(value);
    //       if (value !== null && value !== undefined) {
    //         this.item = Object.assign({}, value)
    //         this.$store.dispatch("procedureWh/setProcedureWhModel", {});
    //         this.isAllowEdit = 0;
    //         // this.onViewProcedure(value)
    //       }
    //     },
    //     deep: true,
    //
    //
    //   },
    //   cDialog(value) {
    //     this.inDialog = value;
    //   },
    //   inDialog(value) {
    //     if (!value) {
    //       this.$emit("closeDialog", "");
    //     }
    //   },
    // },
    methods: {

      resetFrom: function () {
        this.item = {
          status: 1,
        };
      },
      extractValueFromData(value) {
        let data = value.data;
        value.data = "";
        if (data != null && data != undefined && data != "") {
          let ob2 = JSON.parse(data);
          return Object.assign(value, ob2);
        }
        return value

      },

      onCancel: function () {

        router.push({ path: `/procedureWh`, query: this.$route.query });

        //router.push("/procedureWh");
        //this.$emit("closeDialog", "");
      },

      resetTable: function () {
        this.$store.dispatch("procedureWh/setProcedureWhModel", {});
        this.item.typeId = "-1";
      },
      onOpenMaterialCreateDialog: function () {
        this.$emit("openMaterialCreateDialog", this.propsItem);
      },
      onViewProcedure: function () {
        if (this.item.numberG == undefined || this.item.numberG == null || this.item.numberG == "") {
          //message.error(this.$t("lang.common.validate_fail"));
          this.$refs.numberG.focus()
          return;
        }
        if (this.item.typeId == undefined || this.item.typeId == null || this.item.typeId == "") {
          //message.error(this.$t("lang.common.validate_fail"));
          this.$refs.typeId.focus()
          return;
        }
        let procedureId = this.item.procedureId
        let objectSearch = new Object();
        objectSearch.numberG = this.item.numberG;
        objectSearch.typeId = this.item.typeId;
        axios.post(
          process.env.VUE_APP_API_URL +
          "/procedureWh/detail/" + procedureId,
          objectSearch
        ).then((data) => {
            //alert(JSON.stringify(data))
            if (data.lstMotherDay) {
              for (let i = 0; i < data.lstMotherDay.length; i++) {
                data.lstMotherDay[i] = this.extractValueFromData(data.lstMotherDay[i]);
              }
            }
            if (data.lstChildrenDay) {
              for (let i = 0; i < data.lstChildrenDay.length; i++) {
                data.lstChildrenDay[i] = this.extractValueFromData(data.lstChildrenDay[i]);
              }
            }
            this.$store.dispatch("procedureWh/setProcedureWhModel", data);
            this.isAllowEdit = 1;
          }
        );
      },


      onSave: function () {
        // console.log(this.item);
        this.$validator.validate().then((valid) => {
          if (!valid) {
            message.error(this.$t("lang.common.validate_fail"));
            return;
          }
          //console.log(this.lstMotherDay);
          //console.log(this.item);
          let newMotherArr = new Array();
          for (let i = 0; i < this.lstMotherDay.length; i++) {
            let item = new Object();
            item.procedureId = this.item.procedureId;
            item.numberG = this.item.numberG;
            item.numberDay = this.lstMotherDay[i].numberDay;
            item.shrimpAge = this.lstMotherDay[i].shrimpAge;
            item.typeId = this.lstMotherDay[i].typeId;
            item.pongTypeId = this.lstMotherDay[i].pongTypeId;
            this.lstMotherDay[i].data = "";
            item.status = 1;
            item["data"] = JSON.stringify(this.lstMotherDay[i]);
            newMotherArr.push(item);
          }
          let newChildrenArr = new Array();
          for (let i = 0; i < this.lstChildrenDay.length; i++) {
            let item = new Object();
            item.procedureId = this.item.procedureId;
            item.numberG = this.item.numberG;
            item.numberDay = this.lstChildrenDay[i].numberDay;
            item.shrimpAge = this.lstChildrenDay[i].shrimpAge;
            item.typeId = this.lstChildrenDay[i].typeId;
            item.pongTypeId = this.lstChildrenDay[i].pongTypeId;
            this.lstChildrenDay[i].data = "";
            item.status = 1;
            item["data"] = JSON.stringify(this.lstChildrenDay[i]);
            newChildrenArr.push(item);
          }
          axios.post(
            process.env.VUE_APP_API_URL +
            "/procedureWh/saveMaterialDayNew",
            {"lstMotherDay": newMotherArr, "lstChildrenDay": newChildrenArr}
          )
            .then(
              (data) => {
                if (data.success) {
                  message.success(
                    this.$t("lang.common.save_success")
                  );
                  this.resetTable();
                  //this.onCancel();
                } else {
                  message.error(this.$t(data.description));
                }
              },
              (error) => {
                console.log(error);
              }
            );
        });
      },

      onMigrate: function () {

          axios.post(
              process.env.VUE_APP_API_URL +
              "/procedureWh/migrateProcedureFromOldToNew",
              {}
          )
              .then(
                  (data) => {
                    if (data.success) {
                      message.success(
                          this.$t("lang.common.save_success")
                      );

                    } else {
                      message.error(this.$t(data.description));
                    }
                  },
                  (error) => {
                    console.log(error);
                  }
              );

      },

      keyProcess($event) {
        let group = $event.target.getAttribute("data-group");
        let row = parseInt($event.target.getAttribute("data-rownumber"));
        let col = parseInt($event.target.getAttribute("data-colnumber"));
        switch ($event.keyCode) {
          case 13:
            col += 1;
            let id = group + '_' + row + '_' + col;
            var element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            } else {
              row += 1;
              col = 0;
              id = group + '_' + row + '_' + col;
              element = document.getElementById(id);
              if (typeof (element) != 'undefined' && element != null) {
                element.focus();
              }
            }
            $event.preventDefault();
            break;
          case 37:
            // left
            if (col >= 0) {
              col -= 1;
              let id = group + '_' + row + '_' + col;
              let element = document.getElementById(id);
              if (typeof (element) != 'undefined' && element != null) {
                element.focus();
              }
            }
            $event.preventDefault();
            break;
          case 38:
            // up
            if (row >= 0) {
              row -= 1;
              let id = group + '_' + row + '_' + col;
              let element = document.getElementById(id);
              if (typeof (element) != 'undefined' && element != null) {
                element.focus();
              }
            }
            $event.preventDefault();
            break;
          case 39:
            //right
            if (col >= 0) {
              col += 1;
              let id = group + '_' + row + '_' + col;
              // document.getElementById(id).focus();
              var element = document.getElementById(id);
              if (typeof (element) != 'undefined' && element != null) {
                element.focus();
              }
            }
            $event.preventDefault();
            break;
          case 40:
            //down
            if (row >= 0) {
              row += 1;
              let id = group + '_' + row + '_' + col;
              var element = document.getElementById(id);
              if (typeof (element) != 'undefined' && element != null) {
                element.focus();
              }
            }
            $event.preventDefault();
            break;
        }
      },

      back() {
        router.push("/user/list");
      }
    },
    created() {
      this.$store.commit("procedureWh/setIsView", 0);
      if (this.$route.params.id) {
        axios.post(process.env.VUE_APP_API_URL + "/procedureWh/search?pageSize=-1&page=-1", {"procedureId": this.$route.params.id}).then(
          data => {
            if (data.count == 1) {
              this.item = Object.assign({}, data.items[0])
            }
          }
        )
        this.$store.dispatch("procedureWh/setProcedureWhModel", {});
        this.isAllowEdit = 1;

      }
      axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/materialType", {}).then(
        data => {
          let itemFields = this.fields.filter(function (e) {
            return e.name == "typeId";
          });
          if (itemFields != undefined && itemFields.length > 0) {
            itemFields[0].items = data.items;
          }
          this.materialTypes = data.items;

          this.listMaterialType.push({"itemValue": "id", "itemText": "name", "items": data.items});
          this.numberColumnSpanAll = data.items.length + 2;

        }
      )
      axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/material", {}).then(
        data => {
          let itemFields = this.fields.filter(function (e) {
            return e.name == "materialId";
          });
          if (itemFields != undefined && itemFields.length > 0) {
            itemFields[0].items = data.items;
          }
          this.listObject.push({"itemValue": "id", "itemText": "name", "unitText": "name2", "items": data.items});
        }
      )
    },
  };
</script>
<style>

  /*  .procedure_index_tb table {*/
  /*    border-collapse: collapse;*/
  /*    width: 100%;*/
  /*    height: 100px;*/
  /*  }*/


  /*  !*.procedure_index_tb  th {*!*/
  /*  !*  background: #0eae55;*!*/
  /*  !*  position: sticky !important;*!*/
  /*  !*  top: 0 !important;*!*/
  /*  !*  z-index: 1 !important;*!*/
  /*  !*}*!*/

  /*  .procedure_index_tb .v-table__overflow{*/
  /*    height: 500px;*/
  /*    overflow: auto;*/
  /*  }*/


  /*  .procedure_index_tb table td:focus-within {*/
  /*    border:2px solid #006dcc;*/
  /*  }*/


</style>